import { render, staticRenderFns } from "./StatsMemberVip.vue?vue&type=template&id=42664863&"
import script from "./StatsMemberVip.vue?vue&type=script&lang=js&"
export * from "./StatsMemberVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports